"use client";
import "../chunk-BUSYA2B4.js";
import {
  OrganizationProfile as BaseOrganizationProfile,
  SignIn as BaseSignIn,
  SignUp as BaseSignUp,
  UserProfile as BaseUserProfile
} from "@clerk/react";
import React from "react";
import { useEnforceCorrectRoutingProps } from "./hooks/useEnforceRoutingProps";
import {
  APIKeys,
  CreateOrganization,
  GoogleOneTap,
  OrganizationList,
  OrganizationSwitcher,
  PricingTable,
  SignInButton,
  SignInWithMetamaskButton,
  SignOutButton,
  SignUpButton,
  TaskChooseOrganization,
  TaskResetPassword,
  TaskSetupMFA,
  UserAvatar,
  UserButton,
  Waitlist,
  HandleSSOCallback
} from "@clerk/react";
const UserProfile = Object.assign(
  (props) => {
    return /* @__PURE__ */ React.createElement(BaseUserProfile, { ...useEnforceCorrectRoutingProps("UserProfile", props) });
  },
  { ...BaseUserProfile }
);
const OrganizationProfile = Object.assign(
  (props) => {
    return /* @__PURE__ */ React.createElement(BaseOrganizationProfile, { ...useEnforceCorrectRoutingProps("OrganizationProfile", props) });
  },
  { ...BaseOrganizationProfile }
);
const SignIn = (props) => {
  return /* @__PURE__ */ React.createElement(BaseSignIn, { ...useEnforceCorrectRoutingProps("SignIn", props, false) });
};
const SignUp = (props) => {
  return /* @__PURE__ */ React.createElement(BaseSignUp, { ...useEnforceCorrectRoutingProps("SignUp", props, false) });
};
export {
  APIKeys,
  CreateOrganization,
  GoogleOneTap,
  HandleSSOCallback,
  OrganizationList,
  OrganizationProfile,
  OrganizationSwitcher,
  PricingTable,
  SignIn,
  SignInButton,
  SignInWithMetamaskButton,
  SignOutButton,
  SignUp,
  SignUpButton,
  TaskChooseOrganization,
  TaskResetPassword,
  TaskSetupMFA,
  UserAvatar,
  UserButton,
  UserProfile,
  Waitlist
};
//# sourceMappingURL=uiComponents.js.map